import { Card, CardContent, CardHeader } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DeviceCountPieChart } from '~features/devices';
import { ItemCountBarChart } from '~features/items';
import { useUrlSearchParamsOrganisation } from '~features/organisations';
import { UserCountPieChart } from '~features/users';
import { DetailsGridLayout } from '~layouts';
import { longMonthAndYearFormatter } from '~utils/dateUtils';

const rowHeight = '300px';

const OverviewStatisticsContainer = () => {
	const { t } = useTranslation();
	const [organisation] = useUrlSearchParamsOrganisation();

	return (
		<DetailsGridLayout>
			<Card sx={{ height: 1, pb: 1 }}>
				<CardHeader
					title={t('ui.category.users')}
					subheader={longMonthAndYearFormatter.format(new Date())}
				/>
				<CardContent sx={{ width: '100%', height: rowHeight, pb: 1, '&:last-child': { pb: 1 } }}>
					<UserCountPieChart organisationId={organisation?.id} />
				</CardContent>
			</Card>
			<Card sx={{ height: 1, pb: 1 }}>
				<CardHeader
					title={t('ui.category.items')}
					subheader={longMonthAndYearFormatter.format(new Date())}
				/>
				<CardContent sx={{ height: rowHeight, pb: 1, '&:last-child': { pb: 1 } }}>
					<ItemCountBarChart organisationId={organisation?.id} />
				</CardContent>
			</Card>
			<Card sx={{ height: 1, pb: 1 }}>
				<CardHeader
					title={t('nav.category.devices')}
					subheader={longMonthAndYearFormatter.format(new Date())}
				/>
				<CardContent sx={{ height: rowHeight, '&:last-child': { pb: 1 } }}>
					<DeviceCountPieChart organisationId={organisation?.id} />
				</CardContent>
			</Card>
		</DetailsGridLayout>
	);
};

export default OverviewStatisticsContainer;
